// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
    connectedCallback() {
    super.connectedCallback();

    const box = this.querySelector('[data-custom-sizing="true"]');
    if (!box) return;

    const section = this.closest('.shopify-section');
    if (!section) return;

    this.customSizingController = new AbortController();

    const updateSizing = () => {
      const picker = section.querySelector('variant-picker');
      if (!picker) return;

      const selected = picker.querySelectorAll(
        'input[type="radio"]:checked, select'
      );

      const isCustom = Array.from(selected).some(
        (input) => input.value.trim().toLowerCase() === 'custom'
      );

      box.style.display = isCustom ? '' : 'none';

      box.querySelectorAll('input, textarea, select').forEach((input) => {
        input.disabled = !isCustom;
      });
    };

    const listenerOptions = {
      signal: this.customSizingController.signal,
    };

    section.addEventListener('change', updateSizing, listenerOptions);
    section.addEventListener('variant:update', updateSizing, listenerOptions);

    updateSizing();
  }

  disconnectedCallback() {
    this.customSizingController?.abort();
    super.disconnectedCallback();
  }

  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
